<template>
    <div id="breadcums-id">
        <div class="bread-crumb container">
            <div v-if="mobile">
                <ul class="list-breadCrumb" v-if="breadcrumb.length > 0">
                    <li v-for="(data,index) in breadcrumb" class="list-item" :key="index" :class="{'active' : data.status}">
                        <a :href="data.url" v-if="data.title.length<20">{{data.title}}</a> 
                        <a v-else>{{ data.title.substring(0,20)+"..." }}</a> 
                        <span><i class="ion-chevron-right"></i></span>
                    </li>
                </ul>
            </div>
            <div v-else>
                <ul class="list-breadCrumb" v-if="breadcrumb.length > 0">
                    <li v-for="(data,index) in breadcrumb" class="list-item" :key="index" :class="{'active' : data.status}">
                        <a :href="data.url">{{data.title}}</a> 
                        <span><i class="ion-chevron-right"></i></span>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
    import { isMobile } from 'mobile-device-detect';
    export default {
        props:['breadcrumb'],
        data: function() {
            return {
                mobile: false   
            }
        },
        created(){
            this.mobile = isMobile;
        }
    }
</script>

<style lang="scss" scoped>
    #breadcums-id{
        background:#1E1E1E;
    }
    .bread-crumb {
        position: relative;
    }
    .list-breadCrumb {
        display: flex;
        list-style: none;
        padding-left: 0;
        padding: 10px 0;
    }
    .list-item {
        height: 35px;
        line-height: 35px;
        &:last-child span{
            display: none;
        }
        a{
            color: #727272;
            text-transform: capitalize;
            font-weight: 400;
        }
        span {
            margin-left: 5px;
            i {
                font-size: 10px;
            }
        }
    }
    .list-item.active {
        a,a.hover{
            color:#fff;
        }
        span {
            i {
                color:#fff;
            }
        }
    }
    .list-item.visited a, .list-item.visited i{
        color: #E61B33;
    }
    li.list-item span {
        margin: 0 10px;
    }
    // ==================================================  MOBILE RESPONSIVE
	@media (max-width: 490px){
        li.list-item{
            a{
                font-size: 10px;
            }
            span{
                margin: 0px 5px;
                    i{
                        font-size: 8px;
                    }
            }
        }
    }
</style>